import {ApiService} from "../../../config/apiServices";
import {ACCOUNT_USER_PASSWORDRESET_URL, ACCOUNT_USER_PROFILE_URL, ADD_ACCOUNT_ASSIGN_ROLE, CREATE_ACCOUNT_USER_PERMISSION_ROLE_URL, CREATE_ACCOUNT_USER_URL, DEACTIVATE_ACCOUNT_USER_URL, DELETE_ACCOUNT_USER_URL, GET_ACCOUNT_ASSIGN_ROLE__LIST_URL, GET_ACCOUNT_ASSIGN_USER, GET_ACCOUNT_USER_ASSIGN_ROLE_URL, GET_ACCOUNT_USER_LIST_URL, GET_ACCOUNT_USER_PERMISSION_ROLE_URL, GET_ACCOUNT_USER_statistics_URL, GET_ACCOUNT_USER_UPDATE_PERMISSION_ROLE_URL, GET_ASSIGN_ROLE_DELETE, GET_ASSIGN_USER_BY_ID, GET_ROLE_DELETE, UPDATE_ACCOUNT_USER_URL, GEO_BLOCKS_URL, GEO_NYAY_PANCHAYATS_URL} from "../../../config/adminUrlConfig";

export const getAccountUserList = (sort_by = "", order_by = "desc",searchValue = "", perPage,
                           currentPage) => {
    try {
        return ApiService.get(
            `${GET_ACCOUNT_USER_LIST_URL}?sort_by=${sort_by}&order_by=${order_by}&search=${searchValue}&number=${perPage}&page=${currentPage}`
        );
    } catch (error) {
        return error.message;
    }
};

export const getAccountUserStatisticsList = () => {
    try {
        return ApiService.get(
            `${GET_ACCOUNT_USER_statistics_URL}`
        );
    } catch (error) {
        return error.message;
    }
};

export const createAccountUser = (payload) => {
  try {
    return ApiService.post(`${CREATE_ACCOUNT_USER_URL}`, payload);
  } catch (error) {
    return error.message;
  }
};

export const UpdateAccountUser = (id,payload) => {
  try {
    return ApiService.post(`${UPDATE_ACCOUNT_USER_URL}/${id}`, payload);
  } catch (error) {
    return error.message;
  }
};

export const getAccountUserAssignRoleList = (number=0) => {
    try {
        return ApiService.get(
            `${GET_ACCOUNT_USER_ASSIGN_ROLE_URL}?number=${number}`
        );
    } catch (error) {
        return error.message;
    }
};

export const getAccountUserProfile = (id) => {
    try {
        return ApiService.get(
            `${ACCOUNT_USER_PROFILE_URL}/${id}`
        );
    } catch (error) {
        return error.message;
    }
};

export const DeleteAccountUser = (id) => {
    try {
        return ApiService.delete(
            `${DELETE_ACCOUNT_USER_URL}/${id}`
        );
    } catch (error) {
        return error.message;
    }
};


export const DeleteRole = (id) => {
    try {
        return ApiService.delete(
            `${GET_ROLE_DELETE}/${id}`
        );
    } catch (error) {
        return error.message;
    }
};

export const DeleteAssignUser = (roleid,userAssignId) => {
    try {
        return ApiService.delete(
            `${GET_ASSIGN_ROLE_DELETE}/${roleid}/remove-user/${userAssignId}`
        );
    } catch (error) {
        return error.message;
    }
};

export const DeActivateAccountUser = (id,payload) => {
    try {
        return ApiService.post(
            `${DEACTIVATE_ACCOUNT_USER_URL}/${id}`,payload
        );
    } catch (error) {
        return error.message;
    }
};

export const ResetPasswordAccountUser = (id,payload) => {
    try {
        return ApiService.post(
            `${ACCOUNT_USER_PASSWORDRESET_URL}/${id}`,payload
        );
    } catch (error) {
        return error.message;
    }
};
export const getAccountUserRolePermission = (id) => {
    try {
        // Only add role_id query param if id is provided and valid
        const url = id && id !== "" && id !== null && id !== undefined
            ? `${GET_ACCOUNT_USER_PERMISSION_ROLE_URL}?role_id=${id}`
            : GET_ACCOUNT_USER_PERMISSION_ROLE_URL;
        
        return ApiService.get(url);
    } catch (error) {
        return error.message;
    }
};

export const getAccountUserUpdateRolePermission = (id,payload) => {
    try {
        return ApiService.post(
            `${GET_ACCOUNT_USER_UPDATE_PERMISSION_ROLE_URL}/${id}`,payload
        );
    } catch (error) {
        return error.message;
    }
};

export const CreateAccountRolePermission = (payload) => {
    try {
        return ApiService.post(
            `${CREATE_ACCOUNT_USER_PERMISSION_ROLE_URL}`,payload
        );
    } catch (error) {
        return error.message;
    }
};

// Account Role API
export const getAccountRoleList = (sort_by = "", order_by = "desc",searchValue = "", perPage,
                           currentPage
                           ) => {
    try {
        return ApiService.get(
            `${GET_ACCOUNT_ASSIGN_ROLE__LIST_URL}?sort_by=${sort_by}&order_by=${order_by}&search=${searchValue}&number=${perPage}&page=${currentPage}`
        );
    } catch (error) {
        return error.message;
    }
};

export const AddAssignRole = (roleId,payload) => {
  try {
    return ApiService.post(`${ADD_ACCOUNT_ASSIGN_ROLE}/${roleId}/assign-users`, payload);
  } catch (error) {
    return error.message;
  }
};


// ASSIGN ROLE LIST - Use details API instead of assigned-users
export const getAssignRoleList = (id) => {
  try {
    return ApiService.get(
      `${GET_ASSIGN_USER_BY_ID}/${id}/details`
    );
  } catch (error) {
    return error.message;
  }
};

export const getAssignRoleListByID = (roleId) => {

    try {
        return ApiService.get(
            `${GET_ASSIGN_USER_BY_ID}/${roleId}/details`
        );
    } catch (error) {
        return error.message;
    }
};

export const getBlocks = (districtId) =>
    ApiService.get(`${GEO_BLOCKS_URL}?district_id=${districtId}`);

export const getNyayPanchayats = (blockId) =>
    ApiService.get(`${GEO_NYAY_PANCHAYATS_URL}?block_id=${blockId}`);